/** common — EN source (55 keys). */
export const common = {
  time_seconds_short: "{time}s",
  time_minutes_short: "{time}m",
  time_hours_short: "{time}hr",
  time_days_short: "{time}d",
  time_weeks_short: "{time}w",
  time_months_short: "{time}mo",
  time_years_short: "{time}yr",
  time_ago_text: "{time} ago",
  common_app_name: "Linqx",
  common_copy: "Copy",
  common_close: "Close",
  common_skip: "Skip",
  common_submit: "Submit",
  common_continue: "Continue",
  common_message_copied: "Copied.",
  common_error_access_denied: "Access denied",
  common_error_title: "Error",
  common_save: "Save",
  common_create: "Create",
  common_delete: "Delete",
  common_not_found_placeholder_title: "Page not found",
  common_not_found_placeholder_description:
    "Sorry, we couldn't find the page you're looking for.",
  common_not_found_placeholder_button: "Home",
  common_network_error_title: "Check your network",
  common_network_error_description:
    "Something is temporarily wrong with your network connection. Please make sure you are connected to the internet and then reload your app.",
  common_network_error_reload_button: "Reload",
  common_select_photo: "Upload Photo",
  common_take_photo: "Take Photo",
  common_choose_from_library: "Choose from library",
  common_unable_to_save_file: "Unable to save file",
  common_camera_permission_denied:
    "Camera access is required to take a photo. Enable it in Settings.",
  common_message_changes_saved: "Changes has been successfully saved.",
  signin_btn: "Sign in",
  submit_btn: "Submit",
  save: "Save",
  about_activation_finish:
    "By pressing Sign in, you agree to the {terms} and {privacy}",
  about_activation_finish_privacy: "Privacy policy",
  about_activation_finish_terms: "Terms of service",
  connecting: "Connecting..",
  signout: "Sign out",
  no_results: "No results found",
  intro_title: "Linqx",
  intro_description:
    "Enjoy the new experience of connecting with your new friends",
  error_alert_ok: "Ok",
  error_alert_title: "Error",
  error_try_again: "Try again",
  internet_connection_error:
    "Sorry no connection, please check your internet connection settings.",
  about_app_privacy: "Privacy policy",
  about_app_terms_privacy: "Terms & Privacy",
  about_app_terms: "Terms of service",
  tab_item_messages: "Recent Chats",
  tab_item_geo_search: "Geo Search",
  tab_item_profile: "Profile",
  tab_item_events: "Events",
  common_cancel: "Cancel",
  common_loading: "Loading...",
  common_block_confirm_title: "Block this person?",
  common_block_confirm_message:
    "You won't see each other anymore. This can't be undone from here.",
  common_block_confirm_confirm: "Block",
  common_block_error: "Couldn't block. Try again.",
  common_block: "Block",
  common_report: "Report",
  common_linq: "LINQ",
  common_nope: "NOPE",
  report_reason_label: "Reason",
  report_reason_spam: "Spam",
  report_reason_scam: "Scam or fraud",
  report_reason_abuse: "Abuse or inappropriate content",
  report_reason_harassment: "Harassment or bullying",
  report_reason_other: "Other",
  report_message_label: "Message (optional)",
  report_message_placeholder:
    "Add any details that could help us review this report.",
  report_submit: "Submit",
  report_submitting: "Submitting…",
  report_pick_reason: "Please pick a reason.",
  report_no_bridge: "The report bridge is not available.",
  report_standalone: "Running without the Linqx host — submitting is disabled.",
  report_target_label: "Reporting:",
};
